import React, { useContext } from "react";

export interface DialogWizardContextProps {
  step: number;
  stepsCount: number;
  onNextStep?: VoidFunction;
  onPreviousStep?: VoidFunction;
}

const DialogWizardContext = React.createContext<DialogWizardContextProps>({
  step: 0,
  stepsCount: 0,
  onNextStep: () => void 0,
  onPreviousStep: () => void 0,
});

export function useDialogWizardContext(): DialogWizardContextProps {
  return useContext(DialogWizardContext);
}

export default DialogWizardContext;
